import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useFlag } from '@unleash/proxy-client-react';
import React, { useEffect, useState } from 'react';

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
);

export const ReactQueryTooling = (): React.ReactElement => {
  const [showDevtools, setShowDevtools] = useState(false);
  // Note: showTooling, to not show in production and show in www-t
  const showTooling = useFlag('react-query-tooling');

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    window.toggleDevtools = () => setShowDevtools((toggled) => !toggled);
  }, []);

  return (
    <>
      <ReactQueryDevtools initialIsOpen />
      {showTooling && showDevtools && (
        <React.Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </React.Suspense>
      )}
    </>
  );
};
